jQuery(function($){
  $( document ).ready(function() {

      let filters = document.querySelectorAll('.journal--filters--filter');

      if(filters) {
        filters.forEach(function(filter) {
          filter.addEventListener('click', function() {
            
            filterToggleClass(filter);
            filterAjax(filter);
          })
        })
      }


      function filterToggleClass(filter) {
          if(filter.classList.contains('activate')) {
            filter.classList.remove('activate');
            filtersRemoveClass();
 
          } else {
            filtersRemoveClass();
            filter.classList.add('activate');
           
          }
      }

      function filtersRemoveClass() {

        let filtersActivate = document.querySelectorAll('.journal--filters--filter.activate');
        filtersActivate.forEach(function(filter) {
          filter.classList.remove('activate');
        })
      }

      function filterAjax(filter) {
        let queryCategory;
        if(filter.classList.contains('activate')) {

          queryCategory = filter.getAttribute('data-slug');
        } else {
          queryCategory = "";
        }

        let xhr = new XMLHttpRequest();
        xhr.open('POST', ajaxurl.ajaxurl, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4 && xhr.status === 200) {
                document.querySelector('.journal--listing').innerHTML = xhr.responseText;
            }
        };
        xhr.onerror = function() {
            console.error("AJAX request failed");
        };
        xhr.send('action=filter_posts&category=' + encodeURIComponent(queryCategory));
      }


  });
});